module.exports = __webpack_public_path__ + "static/media/IllustrationExample8.b4920ebb.png";